<template>
    <v-data-table
        :headers="headers"
        :items="debtors"
        class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar
              flat
            >
                <v-toolbar-title>Загруженные данные</v-toolbar-title>
                <v-divider
                        class="mx-4"
                        inset
                        vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-btn
                    color="success"
                    class="mb-2 mr-2"
                    @click="() => $router.push({name: 'SocialPersonDebtors'})"
                >
                  К должникам
                </v-btn>
                <!-- <v-btn
                    :disabled="initNormalizeBtn"
                    color="success"
                    class="mb-2 mr-2"
                    @click="$emit('clickNormalizeBtn')"
                >
                  Нормализовать
                </v-btn>
                <v-btn
                    :disabled="initIdentifyAddressBtn"
                    color="success"
                    class="mb-2 mr-2"
                    @click="$emit('clickIdentifyAddressBtn')"
                >
                  Идентифицировать адреса
                </v-btn> -->
                <v-btn
                    :disabled="initDisableUploadDebtorsBtn"
                    color="primary"
                    class="mb-2"
                    @click="$emit('clickUploadDebtorsBtn')"
                >
                    Выгрузить в должников
                </v-btn>
            </v-toolbar>

        </template>
        <template v-slot:[`item.houseAddressObject`]="{item}">
            <v-autocomplete
                @click="() => autocompleteSearchAddress = item.address"
                clearable
                :items="houseAddressObjects"
                item-text="fullAddress"
                item-value="id"
                :value="item.houseAddressObjectId"
                @input="(e) => $emit('inputHouseAddressObject', {uploadId: item.id, houseAddressObjectId: e})"
                :search-input.sync="autocompleteSearchInputs[item.id]"
            ></v-autocomplete>
        </template>
        <template v-slot:[`item.address`]="{item}">
          {{item.address}}
        </template>

        <template v-slot:[`item.actions`]="{item}">
            <v-icon
                v-if="item.status === 'ERROR'"
                color="red"
                class="mr-3"
            >
                mdi-alert
            </v-icon>
            <v-icon
                v-if="item.status === 'OK'"
                color="green"
                class="mr-3"
            >
                mdi-check-circle
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>
import distance from "../../../plugins/natural";
export default {
    name: "SocialDebtorsUploadTable",
    props:{
        initDebtors: {
            type: Array,
            default: () => []
        },
        initHouseAddressObjects:{
            type: Array,
            default: () => []
        },
        initDisableUploadDebtorsBtn: {
            type: Boolean,
            default: false
        },
        initNormalizeBtn: {
          type: Boolean,
          default: false
        },
        initIdentifyAddressBtn: {
          type: Boolean,
          default: false
        },
        initItemErrors: {
          type: Array,
          default: () => []
        },
    },
    data(){
        return {
            autocompleteSearchInputs: {},
            autocompleteSearchAddress: null
        }
    },
    methods:{},
    computed: {
        debtors(){
            return this.initDebtors.map((item) => {
                  let errors = this.initItemErrors.find((err) => err.item === item.id);
                  return {...item, fio: `${item.lastName} ${item.firstName} ${item.middleName}`, address: `${item.city} ${item.address}`, errors: (errors !== undefined ? errors.error : '')};
            });
        },
        headers(){
            const headers = [
                { text: 'ФИО', value: 'fio' },
                { text: 'СНИЛС', value: 'snils' },
                { text: 'Адрес', value: 'address' },
                { text: 'Дата судебного решения', value: 'dateOfJudgment' },
                { text: 'Номер судебного решения', value: 'judgmentNumber' },
                { text: 'Объект в АИС24', value: 'houseAddressObject' },
                { text: '', value: 'actions' },
            ];
            if(0 < this.initItemErrors.length){
              headers.push({ text: 'Ошибки', value: 'errors' })
            }

            return headers;
        },
        houseAddressObjects(){
            if(this.autocompleteSearchAddress){
                return this.initHouseAddressObjects
                    .map((item) => {return {...item, distance: distance.JaroWinklerDistance(this.autocompleteSearchAddress, item.fullAddress)}})
                    .sort((a, b) => b.distance * 100 - a.distance * 100);
            }
            return this.initHouseAddressObjects;
        }
    }
}
</script>
<style scoped>

</style>